import { useLocation } from 'react-router';

import SettingsLandingPage from '@/features/settings/components/SettingsLandingPage';

import { buildSiteComplianceCheckpointSettingsPath } from '../../siteComplianceRouting';

const SiteSettingsPage = () => {
  const location = useLocation();

  return (
    <SettingsLandingPage
      checkpointsPath={buildSiteComplianceCheckpointSettingsPath(
        location.pathname,
      )}
    />
  );
};

export default SiteSettingsPage;
